import { approvedLeaveDatesSet } from "../../assets/config/helpers";

export function createPayrollObject(payrollId, payroll) {
    return {
        payrollId,
        employeeId: payroll.employeeId || "Employee",
        employeeName: payroll.employeeName || "Employee",
        isSuperAdmin: payroll.isSuperAdmin || false,
        joiningDate: payroll.joiningDate,
        employeeDesignation: payroll.employeeDesignation || "",
        grossSalary: calculateGrossSalary(payroll),
        calculatedSalary: calculateSalary(payroll),
        finalAmount: Number(payroll.finalAmount || 0).toFixed(2),
        basicSalary: Number(payroll.basicSalary || 0),
        extraAllowance: Number(payroll.extraAllowance || 0),
        perDaySalary: Number(payroll.perDaySalary || 0),
        extraAmountAdjustment: Number(payroll.extraAmountAdjustment || 0),
        bonus: Number(payroll.bonus || 0),
        daysWorked: Number(payroll.daysWorked || 0),
        requiredWorkingDays: Number(payroll.requiredWorkingDays || 0),
        productiveHours: Number(payroll.productiveHours || 0),
        obtainedLeaves: `${(payroll.obtainedLeaves || 0)}`,
        leavesTaken: Number(payroll.leavesTaken || 0),
        absents: Number(payroll.absents || 0),
        actualAbsents: Number(payroll.actualAbsents || 0),
        lateDeduction: `${Number(payroll.lateDeduction) || '0 - 0'}`,
        month: payroll.month,
        year: Number(payroll.year || 0),
        transactionFees: Number(payroll.transactionFees || 0),
        lateArrivals: Number(payroll.lateArrivals || 0),
        lateDeductionDays: Number(payroll.lateDeductionDays || 0),
        status: payroll.status,
        shift: (payroll.shift || "Morning").toLowerCase(),
        remainingLeaves: Number(payroll.remainingLeaves || 0),
        carryForwardDays: payroll.leavesQuota ? Number(payroll.leavesQuota.carryForwardDays || 0) : 0,
        updatedLeaveQuota: payroll.leavesQuota ? Number(payroll.leavesQuota.updatedLeaveQuota || 0) : 0,
        annualLeavesEncashmentDays: payroll.leavesQuota ? Number(payroll.leavesQuota.leavesEncashmentDays || 0) : 0,
        leavesQuota: payroll.leavesQuota || {},
        leavesEncashmentDays: Number(payroll.leavesEncashmentDays || 0),
        leavesEncashmentAmount: Number(payroll.leavesEncashmentAmount || 0),
        annualLeavesEncashmentDays: Number(payroll.annualLeavesEncashmentDays || 0),
        monthlyLeaves: payroll.monthlyLeaves || [],
        totalNormalHours: Number(payroll.totalNormalHours || 0),
        totalExtraHours: Number(payroll.totalExtraHours || 0),
        lowHoursDays: payroll.lowHoursDays || {},
        totalLowHours: Number(payroll.totalLowHours || 0),
        reqWorkingHours: Number(payroll.reqWorkingHours || 0),
        leaveBalance: Number(payroll.leaveBalance || 0),
        extraAmountAdjustmentNote: payroll.extraAmountAdjustmentNote || "",
        leaveDeductionNote: payroll.leaveDeductionNote || "",
        leavesDeductionDays: payroll.leavesDeductionDays || "",
        perDayProductiveHours: payroll.perDayProductiveHours || "",
        remainingHalfDays: payroll.remainingHalfDays || "",
        halfDays: payroll.halfDays || "",
        totalHalfDayHours: payroll.totalHalfDayHours || "",
        normalDaysWorked: payroll.normalDaysWorked || "",
        newLeaveBalance: payroll.newLeaveBalance || "",
        requiredTotalWorkingHours: Number(payroll.requiredTotalWorkingHours || 0),
        leavesAllowed: Number(payroll.leavesAllowed || 0),
        leavesAvailable: Number(payroll.leavesAvailable || 0),
        DBLeavesTaken: Number(payroll.DBLeavesTaken || 0),
        requiredTotalWorkingDays: payroll.requiredTotalWorkingDays || {},
        normalHoursDays: payroll.normalHoursDays || {},
        absentDays: payroll.absentDays || {},
        totalExtraHoursDays: payroll.totalExtraHoursDays || {},
        empTotalHours: payroll.empTotalHours || 0,
        normalHoursDays: payroll.normalHoursDays || {},
        taxDeduction: Number(payroll.taxDeduction || 0),
        eligibleHolidayDetails: payroll.eligibleHolidayDetails || [],
        workingDays: payroll.workingDays,
        employeeStatus: payroll.employeeStatus,
        lastWorkingDate: payroll.lastWorkingDate || null
    };
}


function calculateGrossSalary(payroll) {
    return Number(payroll.basicSalary || payroll.salary || 0) + Number(payroll.extraAllowance || 0);
}

function calculateSalary(payroll) {
    return Number(payroll.perDaySalary || 0) * Number(payroll.daysWorked || 0);
}

export function getLeavesTooltip(item) {
    const parts = (item.obtainedLeaves || '0 / 0').split(' / ');
    return `Remaining Leaves: ${(Number(parts[1] || 0))}`;
}

export function processLeavesData(leavesData, selectedMonthShort, selectedYear) {
    let maxDays = 0;
    let firstLeaveBalance = 0;
    let latestLeave = null;

    // Convert leaves data to array and sort by creation date
    const leavesArray = Object.keys(leavesData).map(function (key) {
        return leavesData[key];
    }).sort(function (a, b) {
        return a.createdAt - b.createdAt;
    });

    // Process each leave
    for (let i = 0; i < leavesArray.length; i++) {
        const leave = leavesArray[i];
        const leaveYear = new Date(leave.createdAt).getFullYear();

        if (leave.status === "Approved" && leaveYear == selectedYear) {
            const leaveDates = leave.dates.split(" - ");
            const monthMatch = leaveDates.some(function (date) {
                return date.startsWith(selectedMonthShort);
            });

            if (monthMatch) {
                // Track first leave balance
                if (firstLeaveBalance === 0 && leave.leavesBalance) {
                    firstLeaveBalance = parseFloat(leave.leavesBalance);
                }

                // Track latest leave
                if (!latestLeave || leave.createdAt > latestLeave.createdAt) {
                    latestLeave = leave;
                }

                // Add approved leave dates
                leaveDates.forEach(function (date) {
                    approvedLeaveDatesSet.add(date);
                });

                // Sum total leave days
                maxDays += leave.noofdays ? leave.noofdays : 0;
            }
        }
    }

    console.log("leave max days", maxDays);

    return {
        obtainedLeaves: latestLeave ? maxDays : 0,
        leaveBalance: firstLeaveBalance
    };
}

// Helper methods for template
export function getStatusClass(status) {
    return {
        'payroll-table-status-processed': status === 'Processed',
        'payroll-table-status-draft': status === 'Draft',
        'payroll-table-status-pending': status !== 'Processed' && status !== 'Draft'
    };
}

export function getLeavesTaken(item) {
    const parts = (item.obtainedLeaves || '0 / 0').split(' / ');
    return parts[0] || 0;
}

export function getLateDeductionTooltip(item) {
    const parts = (item.lateDeduction || '0 - 0').split(' - ');
    return `Late Deduction Days: ${parts[1] || 0}`;
}

export function formatLateDeduction(item) {
    const parts = (item.lateDeduction || '0 - 0').split(' - ');
    return (parseFloat(parts[0]) || 0).toFixed(2);
}


// WEBPACK FOOTER //
// ./src/components/PayrollManagement/payrollHelper.js